
import { useScrollReveal } from '../../../hooks/useScrollReveal';

const outcomes = [
  { label: 'Reduced operational friction', metric: '40%', metricLabel: 'avg. efficiency gain' },
  { label: 'Improved decision intelligence', metric: '3x', metricLabel: 'faster insights' },
  { label: 'Increased margin efficiency', metric: '25%', metricLabel: 'cost reduction' },
  { label: 'Portfolio-wide scalability', metric: '10x', metricLabel: 'deployment scale' },
  { label: 'Measurable competitive advantage', metric: '90%', metricLabel: 'client retention' },
];

export default function TheOutcome() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollReveal(0.2);
  const { ref: gridRef, isVisible: gridVisible } = useScrollReveal(0.1);

  return (
    <section id="outcomes" className="py-32 md:py-40 bg-[#0B0D10] relative overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/4c21515ffe689dfbcb58fea0593da4fd.jpg"
          alt="Outcomes background"
          className="w-full h-full object-cover object-top opacity-20"
        />
      </div>
      <div className="absolute inset-0 bg-[#0B0D10]/80"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 lg:px-8">
        <div ref={headerRef} className={`text-center mb-20 transition-all duration-1000 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <p className="text-sm tracking-[0.25em] uppercase text-[#3A5F8C] mb-4 font-medium">Results</p>
          <h2 className="text-4xl md:text-5xl lg:text-[56px] font-bold text-[#F5F7FA] tracking-tight leading-[1.1] mb-6">
            AI That Impacts EBITDA —<br />Not Slide Decks.
          </h2>
          <p className="text-lg text-[#F5F7FA]/50 max-w-2xl mx-auto">
            When implemented correctly, AI delivers measurable business performance — not experimentation.
          </p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {outcomes.map((outcome, index) => (
            <div
              key={index}
              className={`text-center p-8 rounded-2xl bg-[#2A2E35]/40 backdrop-blur-sm border border-[#2A2E35]/60 hover:border-[#3A5F8C]/30 transition-all duration-500 group ${gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: gridVisible ? `${index * 100}ms` : '0ms' }}
            >
              <p className="text-3xl md:text-4xl font-bold text-[#F5F7FA] mb-1 tracking-tight group-hover:text-white transition-colors">
                {outcome.metric}
              </p>
              <p className="text-xs text-[#3A5F8C] mb-4 font-medium uppercase tracking-wider">
                {outcome.metricLabel}
              </p>
              <p className="text-sm text-[#F5F7FA]/60 leading-relaxed">
                {outcome.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
